import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

// Add startIndex as a prop
const VideoModal = ({ videos, isOpen, onClose, startIndex }) => {
  const [activeIndex, setActiveIndex] = useState(startIndex);
  const videoRef = useRef(null);

  // Set the initial index and reset when modal opens
  useEffect(() => {
    if (isOpen) {
      setActiveIndex(startIndex);
    }
  }, [isOpen, startIndex]);

  // Autoplay current video
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
      videoRef.current
        .play()
        .catch(() => console.log("Autoplay blocked by browser"));
    }
  }, [activeIndex, isOpen]);

  const nextVideo = () => setActiveIndex((prev) => (prev + 1) % videos.length);
  const prevVideo = () =>
    setActiveIndex((prev) => (prev - 1 + videos.length) % videos.length);

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <div className="relative w-full max-w-4xl">
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-2 right-2 z-10 bg-white/20 p-2 rounded-full hover:bg-white/40"
          >
            <X className="text-white w-6 h-6" />
          </button>

          {/* Video */}
          <video
            ref={videoRef}
            key={activeIndex}
            className="w-full rounded-2xl shadow-lg"
            muted
            controls
            playsInline
          >
            <source src={videos[activeIndex]} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          {/* Navigation Arrows */}
          <button
            onClick={prevVideo}
            className="absolute left-2 top-1/2 -translate-y-1/2 bg-gray-800/60 p-2 rounded-full hover:bg-gray-800/40"
          >
            <ChevronLeft className="text-white w-6 h-6" />
          </button>
          <button
            onClick={nextVideo}
            className="absolute right-2 top-1/2 -translate-y-1/2 bg-gray-800/60 p-2 rounded-full hover:bg-gray-800/40"
          >
            <ChevronRight className="text-white w-6 h-6" />
          </button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default VideoModal;
